import React from 'react';
import { Button, Text } from '@myinterview/component-library';
import { DoneInvokeEvent } from 'xstate';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { EVENTS as WIDGET_EVENTS, IWidgetMachineProps } from '../interfaces/widgetInterface';
import { SetupChecks } from './SetupChecks';
import { FAST_UPLOAD_SPEED } from '../utils/constants.utils';

interface IProps extends IWidgetMachineProps {
  isPracticeDisabled: boolean;
  recordWithoutVideo?:boolean;
}

export const Setup:React.FC<IProps> = ({ widgetMachine, sendToWidget, isPracticeDisabled, recordWithoutVideo }) => {
  const canRetrySpeedTest = widgetMachine.nextEvents.includes(WIDGET_EVENTS.RETRY) && widgetMachine.context.speedTestResult < FAST_UPLOAD_SPEED;
  const canStartInterview = widgetMachine.can(WIDGET_EVENTS.QUESTION_MODE as unknown as DoneInvokeEvent<any>);
  const { isResumed } = widgetMachine.context;
  const { t } = useTranslation();
  const onRetry = () => {
    sendToWidget(WIDGET_EVENTS.RETRY);
  };
  const startButtonClassNames = classNames({
    'myinterview-widget-outer__mode-button': true,
    'myinterview-widget-outer__mode-button--start': true,
    'myinterview-widget-outer__mode-button--single': isPracticeDisabled,
  });

  return (
    <div className="myinterview-widget-outer__setup myinterview-widget--rtl-support">
      <Text className="myinterview-widget-outer__title" size="H2-Bold">{t('setup.title')}</Text>
      <SetupChecks recordWithoutVideo={recordWithoutVideo} checksState={widgetMachine.context.checksState} checksMessages={widgetMachine.context.checksMessage} canRetrySpeedTest={canRetrySpeedTest} onRetry={onRetry} />
      <div className="myinterview-widget-outer__mode-wrapper">
        {!isPracticeDisabled && (
        <Button
          className="myinterview-widget-outer__mode-button"
          onClick={() => sendToWidget(WIDGET_EVENTS.PRACTICE_MODE)}
          backgroundColor="special"
          disabled={!canStartInterview}
        >
          {t('buttons.btn_practice')}
        </Button>
        )}
        <Button
          className={startButtonClassNames}
          color="special"
          backgroundColor="white"
          onClick={() => sendToWidget(WIDGET_EVENTS.QUESTION_MODE)}
          disabled={!canStartInterview}
        >
          {t(isResumed ? 'welcome.resumeInterview' : 'buttons.btn_start').toUpperCase()}
        </Button>
      </div>
    </div>
  );
};
